
const aaa = [
    {
        path: "group",
        component: () => import("@/views/chanpin/group/group.vue"),
        meta:{title:'套餐',keepAlive:true},
    },
    {
        path: "addgoodsgroup",
        component: () => import("@/views/chanpin/group/addgoodsgroup.vue"),
        meta:{title:'编辑商品套餐'},
    },
    {
        path: "addquchonggroup",
        component: () => import("@/views/chanpin/group/addquchonggroup.vue"),
        meta:{title:'编辑驱虫套餐'},
    },
    {
        path: "addyimiaogroup",
        component: () => import("@/views/chanpin/group/addyimiaogroup.vue"),
        meta:{title:'编辑疫苗套餐'},
    },
    {
        path: "addservicegroup",
        component: () => import("@/views/chanpin/group/addservicegroup.vue"),
        meta:{title:'编辑服务套餐'},
    },
    
	{
		path: "relationconsum",
		component: () => import("@/views/chanpin/consumables/relationconsum.vue"),
		meta:{title:'关联耗材'},
	}
	
]
export default aaa;